import React from 'react';
import { Calendar, Clock, ArrowUp, Check, X, RefreshCcw, DollarSign, Send } from 'lucide-react';

const StatusTimelineBootstrap = ({ updates, currentStatus }) => {

  console.log('StatusTimelineBootstrap', updates, currentStatus);

  // Sort updates by date (newest first)
  const sortedUpdates = [...updates].sort((a, b) => b.date.getTime() - a.date.getTime());

  // Function to get the appropriate icon based on status
  const getStatusIcon = (status) => {
    switch (status) {
      case 'Draft':
        return <Clock size={16} />;
      case 'Sent':
        return <Send size={16} />;
      case 'Partially_Paid':
        return <DollarSign size={16} />;
      case 'Paid':
        return <Check size={16} />;
      case 'Cancelled':
        return <X size={16} />;
      case 'Credited':
        return <RefreshCcw size={16} />;
      default:
        return <Calendar size={16} />;
    }
  };

  // Function to get a formatted status name
  const getStatusName = (status) => {
    const statusMap = {
      'Draft': 'Utkast',
      'Sent': 'Skickad',
      'Partially_Paid': 'Delvis betald',
      'Paid': 'Betald',
      'Cancelled': 'Makulerad',
      'Credited': 'Krediterad'
    };

    return statusMap[status] || status;
  };

  // Function to get status badge color
  const getStatusColor = (status) => {
    switch (status) {
      case 'Paid':
        return 'success';
      case 'Partially_Paid':
        return 'info';
      case 'Sent':
        return 'warning';
      case 'Draft':
        return 'secondary';
      case 'Cancelled':
        return 'dark';
      case 'Credited':
        return 'primary';
      default:
        return 'primary';
    }
  };

  return (
    <div className="card">
      <div className="card-header">
        <h5 className="card-title mb-0">Status Timeline</h5>
      </div>
      <div className="card-body">
        <div className="d-flex flex-column gap-4">
          {sortedUpdates.map((update, index) => (
            <div key={index} className="d-flex gap-3">
              <div className="d-flex flex-column align-items-center">
                <div className="rounded-circle d-flex align-items-center justify-content-center text-primary" style={{ width: '32px', height: '32px' }}>
                  {getStatusIcon(update.status)}
                </div>
                {index < sortedUpdates.length - 1 && (
                  <div className="bg-secondary bg-opacity-10"
                    style={{ width: '2px', height: '24px', marginTop: '4px' }}>
                  </div>
                )}
              </div>
              <div>
                <p className="fw-medium mb-1">
                  Status changed to{' '}
                  <span className={`badge text-${getStatusColor(update.status)}`}>
                    {getStatusName(update.status)}
                  </span>
                </p>
                <p className="text-muted small mb-1">
                  {update.date.toLocaleDateString('sv-SE', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </p>
                {update.note && <p className="small mb-0">{update.note}</p>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatusTimelineBootstrap;
